module.exports = __webpack_public_path__ + "media/assets/images/app/FormsNew__body__sent__img-b5964b19d5400dfd2f46259de617ea92.svg";